import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../../shared/core.module';
import { ButtonCloseComponent } from '../button-close/button-close.component';
import { CopyToClipboardButtonComponent } from '../copy-to-clipboard-button/copy-to-clipboard-button.component';
import { LayoutModule } from '../layout.module';
import { ToggleReaderComponent } from '../toggle-reader/toggle-reader.component';
import { DateLangFormatComponent } from './date-lang-format/date-lang-format.component';
import { EulaComponent } from './eula/eula.component';
import { SidenavComponent } from './sidenav.component';
import { ProfileButtonComponent } from './profile-button/profile-button.component';
import { DateLangFormatDialogComponent } from './date-lang-format-dialog/date-lang-format-dialog.component';
import { MatBadge } from '@angular/material/badge';
import { HelpDrawerComponent } from './help-drawer/help-drawer.component';
import { NgOptimizedImage } from '@angular/common';

@NgModule({
  declarations: [
    EulaComponent,
    SidenavComponent,
    DateLangFormatComponent,
    DateLangFormatDialogComponent,
    ProfileButtonComponent,
  ],
  exports: [SidenavComponent],
  imports: [
    CoreModule,
    RouterModule,
    LayoutModule,
    ButtonCloseComponent,
    ToggleReaderComponent,
    CopyToClipboardButtonComponent,
    MatBadge,
    HelpDrawerComponent,
    NgOptimizedImage,
  ],
})
export class SidenavModule {}
